import 'zone.js' // Included with Angular CLI.

// Otherwise `braintree-web` throws an error
// https://github.com/angular/angular-cli/issues/8160#issuecomment-386153833
const w: any = window
w.global = window

// to fix "Uncaught ReferenceError: process is not defined"
// w.process ||= {
//   env: { DEBUG: undefined },
//   version: [],
// }

// Fix "missing __importDefault", as per https://github.com/angular/angular/issues/32215#issuecomment-543459862
// w.__importDefault =
//   (w && w.__importDefault) ||
//   function (mod: any) {
//     return mod && mod.__esModule ? mod : { default: mod }
//   }

// this hopefully fixes "ERROR ReferenceError: regeneratorRuntime is not defined"
// import 'regenerator-runtime/runtime.js'

declare global {
  interface Window {
    mixpanel: any
    appVer: string
    ga: any
    ApplePaySession: any
    Cookiebot?: Cookiebot
    state: any
    reset: any
  }
}

interface Cookiebot {
  name: string
  consented: boolean
  declined: boolean
  hasResponse: boolean
  doNotTrack: boolean
  consent: {
    marketing: boolean
    statistics: boolean
    preferences: boolean
    necessary: boolean
    stamp: string
  }
  regulations: {
    gdprApplies: boolean
    ccpaApplies: boolean
    lgpdApplies: boolean
  }

  show: () => void
  hide: () => void
  renew: () => void
  getScript: (url: string, async: boolean, callback: () => void) => void
  runScripts: () => void
  withdraw: () => void
  submitCustomConsent: (
    optinPreferences: boolean,
    optinStatistics: boolean,
    optinMarketing: boolean,
  ) => void
}
